import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountContactSavedListings} from "./AccountContactSavedListings.js";

export class ZIDXAccountContactHiddenListings implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountContactHiddenListingsContainer";
    }
    render(){
        // console.log("contact hidden listings");
        var savedListings=new ZIDXAccountContactSavedListings(this.zidx);
        savedListings.bindEvents();
    }
}